<ion-header class="m-grading-page-header">
  <ion-row class="ion-align-items-center ion-justify-content-between">
    <ion-col size="12" class="ion-no-padding">
      <monorepo-bctx-header
        [bctxHeader]="headerInput"
        (onBack)="handleExit()"
        [enableBack]="true"
      ></monorepo-bctx-header>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="m-grading-page-content">
  <ion-row class="content-row">
    <ion-col size="8" class="size-tiles-block-col">
      <ion-row class="ion-justify-content-between ion-align-items-center heading-block">
        <ion-col size="3" class="ion-padding-start">Size List</ion-col>
        <ion-col size="8">
          <ion-row class="ion-align-items-center" style="flex-direction: row-reverse">
            <div class="filter-icon" (click)="filterSizeItem()">
              <ion-img [src]="sizeFilterIcon"></ion-img>
            </div>
            <div class="undo-icon" (click)="handleUndo()">
              <ion-img [src]="undoIcon"></ion-img>
            </div>
            <div class="sync-icon" (click)="handleSync()">
              <ion-img [src]="syncIcon"></ion-img>
            </div>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="size-tiles-block">
        <ng-container *ngFor="let item of sizeListVM; let i = index">
          <ng-container *ngIf="visibleSizeList[i].status">
            <ion-col size-lg="4" size-md="6" class="ion-no-padding ion-margin-bottom ion-padding">
              <div
                class="size-tile ion-activatable ripple-parent rounded-rectangle"
                [ngClass]="{
                  'size-tile--disabled': item.savedData.wipQty - item.currentCount <= 0
                }"
                (click)="updateActiveQty(item.savedData.name)"
              >
                <div class="actual-count">Qty Selected: {{ item.currentCount }}</div>

                <div class="size-name">{{ item.savedData.name }}</div>

                <div class="wip-and-sent-receive-info">
                  <ion-row class="ion-justify-content-around">
                    <div>
                      WIP:
                      {{
                        type === 'SEND'
                          ? item.savedData.wipQty - item.currentCount
                          : item.savedData.sentQty - item.savedData.receiveQty - item.currentCount
                      }}
                    </div>
                    <div>|</div>
                    <div *ngIf="type === 'SEND'">Total Sent: {{ item.savedData.receiveQty }}</div>
                    <div *ngIf="type === 'RECEIVE'">
                      Total Rcvd: {{ item.savedData.receiveQty }}/{{ item.savedData.sentQty }}
                    </div>
                  </ion-row>
                </div>
                <ion-ripple-effect></ion-ripple-effect>
              </div>
            </ion-col>
          </ng-container>
        </ng-container>
      </ion-row>
    </ion-col>
    <ion-col size="4" class="number-pad-block-col">
      <div class="number-pad">
        <monorepo-bulk-count-pad
          [enableBulkChange]="enableBulkChange"
          [count]="count"
          (bulkCount)="handleBulkCount($event)"
        ></monorepo-bulk-count-pad>
      </div>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer class="m-grading-page-footer">
  <ion-row>
    <ion-col
      size="4"
      class="go-back-button"
      [ngClass]="{ 'go-back-button--disabled': totalQty === 0 }"
      (click)="handleSaveAndExit()"
      >Save & Exit</ion-col
    >
    <ion-col
      size="8"
      class="proceed-button"
      [ngClass]="{ 'proceed-button--disabled': totalQty === 0 }"
      (click)="handleProceed()"
    >
      <ion-row class="proceed-button__row ion-justify-content-between">
        <div>Total Qty: {{ totalQty }}</div>
        <ion-row class="ion-align-items-center">
          {{ proceedTxt }}
          <ion-img [src]="proceedIcon" class="proceed-button__icon"></ion-img>
        </ion-row> </ion-row
    ></ion-col>
  </ion-row>
</ion-footer>
